import { Card, Divider } from "antd";
import { useParams, useSearchParams } from "react-router-dom";
import { number_3_3 } from "../../utilities";
import { FiCheck, FiX } from "react-icons/fi";

import "./style.css";
import { useEffect, useState } from "react";
import axios from "axios";
import { api } from "../../api/url";

import Button from "../../components/Button";
import { toast } from "react-hot-toast";

const AboutUs = (props) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { id, doctorid } = useParams();
  const [loading, setLoading] = useState(true);
  const [btnLoading, setBtnLoading] = useState(false);
  const [visitInfo, setVisitInfo] = useState({});
  const [totalPrice, setTotalPrice] = useState();
  const [bank, setBank] = useState(0);

  return (
    <div className="factor-container ">
      <Card className="factor-card">
        <div className="success-factor-icon">
          <FiCheck />
        </div>

        <h4>پرداخت موفق</h4>
        <div className="visit-modal-confirm-content">
          <div className="row">
            <div className="col-lg-6 col-6 ">شناسه نوبت:</div>
            <div className="col-lg-6 col-6 visit-modal-left">
              {visitInfo?.userFullName}
            </div>
          </div>
          <div className="row">
            <div className="col-lg-6 col-6">
              تاریخ ثبت: {visitInfo?.userNationalCode}
            </div>
            <div className="col-lg-6 col-6 visit-modal-left">
              شناسه مرجع: {localStorage.getItem("cellphone")}
            </div>
          </div>

          <Divider />
          <div className="row">
            <div className="col-lg-6  col-6">مبلغ تراکنش:</div>
            <div className="col-lg-6 col-6 visit-modal-left">
              {number_3_3(String(totalPrice))} ریال
            </div>
          </div>
          <Divider />
        </div>

        <Button
          isSubmitting={btnLoading}
          onClick={() => (window.location.href = "/profile/transactions")}
          className="modal-phonenumber-container-button"
        >
          صفحه تراکنش‌ها
        </Button>
      </Card>
    </div>
  );
};

export default AboutUs;
